import React, { useEffect, useState } from 'react';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import { Badge, Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import axiosInstance from '../services/axiosInterceptor';

const emptyForm = { ruleId: null, ruleName: '', defaultPoints: 5, isActive: 1 };

export default function DisciplineConductRules() {
  const setSkin = useState(localStorage.getItem('skin-mode') ? 'dark' : '')[1];
  const [rules, setRules] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchRules = () => {
    axiosInstance.get('/api/discipline/conduct-rules?includeInactive=1')
      .then(res => setRules(res.data || []))
      .catch(() => setError('ไม่สามารถโหลดรายการความผิดได้'));
  };

  useEffect(fetchRules, []);

  const submit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    const payload = {
      ruleId: form.ruleId,
      ruleName: form.ruleName.trim(),
      defaultPoints: Number(form.defaultPoints),
      isActive: Number(form.isActive)
    };
    const request = form.ruleId
      ? axiosInstance.put('/api/discipline/conduct-rules', payload)
      : axiosInstance.post('/api/discipline/conduct-rules', payload);

    request
      .then(() => {
        setForm(emptyForm);
        fetchRules();
      })
      .catch(err => setError(err.response?.data?.message || 'ไม่สามารถบันทึกได้'))
      .finally(() => setSaving(false));
  };

  const edit = (rule) => {
    setForm({
      ruleId: rule.rule_id,
      ruleName: rule.rule_name,
      defaultPoints: rule.default_points,
      isActive: rule.is_active
    });
  };

  return (
    <>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="mb-4">
          <ol className="breadcrumb fs-sm mb-1">
            <li className="breadcrumb-item">ฝ่ายปกครอง</li>
            <li className="breadcrumb-item active">รายการความผิด</li>
          </ol>
          <h4 className="main-title mb-0">จัดการรายการความผิด</h4>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <Row className="g-3">
          <Col lg={4}>
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6" className="mb-0">{form.ruleId ? 'แก้ไขรายการ' : 'เพิ่มรายการใหม่'}</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={submit}>
                  <Form.Group className="mb-3">
                    <Form.Label>รายการความผิด</Form.Label>
                    <Form.Control
                      value={form.ruleName}
                      onChange={e => setForm({ ...form, ruleName: e.target.value })}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>คะแนนที่ตัดเริ่มต้น</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      max="100"
                      value={form.defaultPoints}
                      onChange={e => setForm({ ...form, defaultPoints: e.target.value })}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>สถานะ</Form.Label>
                    <Form.Select value={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.value })}>
                      <option value={1}>ใช้งาน</option>
                      <option value={0}>ปิดใช้งาน</option>
                    </Form.Select>
                  </Form.Group>
                  <div className="d-flex gap-2">
                    <Button type="submit" disabled={saving}>
                      {saving ? 'กำลังบันทึก' : 'บันทึก'}
                    </Button>
                    {form.ruleId && (
                      <Button variant="outline-secondary" type="button" onClick={() => setForm(emptyForm)}>
                        ยกเลิก
                      </Button>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={8}>
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6" className="mb-0">Master list</Card.Title>
              </Card.Header>
              <Card.Body className="p-0">
                <Table responsive hover className="mb-0">
                  <thead className="table-secondary">
                    <tr>
                      <th>รายการ</th>
                      <th className="text-center" style={{ width: 140 }}>คะแนนตัด</th>
                      <th className="text-center" style={{ width: 120 }}>สถานะ</th>
                      <th className="text-center" style={{ width: 110 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rules.map(rule => (
                      <tr key={rule.rule_id}>
                        <td>{rule.rule_name}</td>
                        <td className="text-center fw-semibold text-danger">{rule.default_points}</td>
                        <td className="text-center">
                          {Number(rule.is_active)
                            ? <Badge bg="success">ใช้งาน</Badge>
                            : <Badge bg="secondary">ปิดใช้งาน</Badge>}
                        </td>
                        <td className="text-center">
                          <Button variant="outline-primary" size="sm" onClick={() => edit(rule)}>
                            แก้ไข
                          </Button>
                        </td>
                      </tr>
                    ))}
                    {rules.length === 0 && (
                      <tr><td colSpan={4} className="text-center text-secondary py-4">ยังไม่มีรายการความผิด</td></tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
}
